export class POLOAuthConstants {
  public static get redirectUri(): string {
    return window.OAUTH_CONFIG.redirect_uri;
  }

  public static get client_id(): string{
    return window.OAUTH_CONFIG.client_id
  }
}
